// extracted by mini-css-extract-plugin
export var attachment = "_qy-a";
export var emailContainer = "_qy-4";
export var emailContentPaddedContainer = "_qy-b";
export var emailHeader = "_qy-6";
export var emailIframe = "_qy-3";
export var emailInfoIcon = "_qy-9";
export var emailShortenedSummary = "_qy-e";
export var infoDropdown = "_qy-0";
export var infoRowBoundedContent = "_qy-d";
export var internal = "_qy-5";
export var merchant = "_qy-8";
export var messageInputContainer = "_qy-h";
export var normal = "_qy-7";
export var replyCard = "_qy-f";
export var subtleButton = "_qy-1";
export var subtleButtonIconContainer = "_qy-2";
export var toggleViewRepliesButton = "_qy-c";
export var wrappingText = "_qy-g";